import React, { useContext } from "react"
import Loader from "../../../../../Components/BifrostPageComponent/Loader/Loader"
import userInfoContext from "../../../../../store/userInfoContext"
import OrganizationView from "./OrganizatianInfoPage/OrganizationView"

const ActivityPage = () => {
	const userInfo = useContext(userInfoContext)

	return !userInfo ? (
		<div style={{ height: "100vh" }}>
			<Loader />
		</div>
	) : (
		<section className={"bifrost-table-panel users-table"}>
			<OrganizationView />
		</section>
	)
}

export default ActivityPage
